export { BaseEntityAdapter } from "./base-entity-adapter";
export { FallbackEntityAdapter } from "./fallback-entity-adapter";
